// extracted by mini-css-extract-plugin
export var Pair = "default-module--Pair--1CSx4";
export var Key = "default-module--Key--1sIqY";
export var Value = "default-module--Value--15p8K";